
import { Component, Prop, Vue } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface, { Ticket } from '@/services/Internal-Tickets/interfaces';

@Component({
  inject: ['internalTicketsRepository'],
})
export default class TicketDetailsEditDialog extends Vue {
  @Prop() dialogVisible: boolean;
  @Prop() detailName: string;
  @Prop() ticket: Ticket;

  private selectedOption: string = '';
  public optionsList: any[] = [];

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  private get transformedOptionsList() {
    if (this.detailName === 'status' || this.detailName === 'component' || this.detailName === 'priority') {
      return this.optionsList.map((item) => ({
        ...item,
        displayText: item.name,
        value: item.id
      }));
    } else {
      return this.optionsList.map((item) => ({
        ...item,
        displayText: item.email,
        value: item.userId
      }));
    }
  }

  public cancelOption() {
    this.$emit('cancelEditDialog', false);
  }

  public async saveOption(selectedOption: string) {
    const ticketId = String(this.ticket.id);
    if (this.detailName === 'assignee') {
      await this.internalTicketsRepository.assignTicket(ticketId, String(this.selectedOption));
    }
    else if (this.detailName === 'component') {
      await this.internalTicketsRepository.changeComponent(ticketId, Number(this.selectedOption));
    }
    else if (this.detailName === 'status') {
      await this.internalTicketsRepository.changeStatus(ticketId, Number(this.selectedOption));
    }
    else if (this.detailName === 'priority') {
      await this.internalTicketsRepository.changePriority(ticketId, Number(this.selectedOption));
    }
    this.$emit('refresh',ticketId)
  }

  public async loadOptions() {
    if (this.detailName === 'assignee') {
      await this.internalTicketsRepository.refreshAssignees();
      this.optionsList = await this.internalTicketsRepository.getAssignees();
    } else if (this.detailName === 'component') {
      this.optionsList = await this.internalTicketsRepository.getComponents();
    } else if (this.detailName === 'priority') {
      this.optionsList = await this.internalTicketsRepository.getPriorities();
    } else if (this.detailName === 'status') {
      this.optionsList = await this.internalTicketsRepository.getStatuses();
    }
  }
}
